import "../CSS/VcChangeOwner.css";
import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { getAPIHostURL } from "../../ClientConfig";
import { AppRelevantDataContext } from "../../AppContext";
import { FaQrcode, FaTimes } from "react-icons/fa";
import {PROD_DEVC_OWNER_USER_ID} from "../../VcConstants"

function VcChangeOwner() {
  const context = useContext(AppRelevantDataContext);
  const [state, setState] = useState({
  deviceId: "", // optional / can be removed later
  existingOwnerEmail: "",
  allowViewAll: false,
  selectedDevice: "", 
  searchedDeviceText: "", 
  searchedDevices: [],   // NEW
  newEmail: "",
  deviceList: [],
  deviceListText: "",
  devcIDQRCodeFlag: false,
  showOwnerDetails: false, 
  highlightedSearchedDeviceId: null,

    //verify button click
  ownerDetails: null,  
  
  showNewOwnerDetails : false,
  newOwnerDetails:null,
  // verify button click
  errors: {
    existingOwnerEmail: "",
    newEmail: "",
    deviceList:"",
    others:"",
  },
});
const isAllSelected = state.deviceList.length > 0 && state.searchedDevices.length === state.deviceList.length;

const validEmailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
const handleChange = (e) => {
  const { name, value } = e.target;
  let errors = { ...state.errors };

  if (name === "existingOwnerEmail") {
    if (!value || value.trim() === "") {
      // Reset everything for existing email
      setState({
        deviceId: "",
        existingOwnerEmail: "",
        allowViewAll: false,
        selectedDevice: "",
        highlightedSearchedDeviceId: null,
        searchedDeviceText: "",
        searchedDevices: [],
        newEmail: "",
        newOwnerOthers:"",
        deviceList: [],
        deviceListText: "",
        devcIDQRCodeFlag: false,
        showOwnerDetails: false,
        ownerDetails: null,
        showNewOwnerDetails: false,
        newOwnerDetails: null,
        errors: {
          existingOwnerEmail: "",
          newEmail: "",
          deviceList: "",
          newOwnerOthers:"",
          others:"",
        },
      });
      return;
    }

    errors.existingOwnerEmail =
      value && !validEmailRegex.test(value) ? "Email ID is not valid!" : "";
    errors.existingOwnerOthers = "";
    errors.newOwnerOthers = "";

    setState((prev) => ({
      ...prev,
      existingOwnerEmail: value,
      errors,
      showOwnerDetails: false,
      ownerDetails: null,
      deviceListText: "",
      highlightedSearchedDeviceId: null,
      deviceList: [],
      searchedDevices: [],
      selectedDevice: "",
      newEmail: "",   
      newOwnerOthers:"",
      showNewOwnerDetails: false,
      newOwnerDetails: null,
      existingOwnerOthers: "",
      others: "",
      newOwnerOthers: "",
    }));
    return;
  }

  if (name === "newEmail") {
    if (!value || value.trim() === "") {
      // Reset everything for new email
      setState((prev) => ({
        ...prev,
        newEmail: "",
        showNewOwnerDetails: false,
        newOwnerDetails: null,
        errors: {
          ...prev.errors,
          newEmail: "",
          newOwnerOthers: "",
          deviceList: "",
          others:"",
        },
      }));
      return;
    }

    errors.newEmail =
      value && !validEmailRegex.test(value) ? "Email ID is not valid!" : "";
    errors.newOwnerOthers = "";

    setState((prev) => ({
      ...prev,
      newEmail: value,
      errors,
      showNewOwnerDetails: false,
      newOwnerDetails: null,
      newOwnerOthers: "",
    }));
    return;
  }
  
  // For any other field
  setState((prev) => ({
    ...prev,
    [name]: value,
    errors,
  }));
};

//Function to verify the existing owner email.
const handleVerifyOwner = (e) => {
  e.preventDefault();
  let modifiedState = { ...state };
  modifiedState.errors.existingOwnerEmail = "";
  modifiedState.errors.existingOwnerOthers = "";
  modifiedState.errors.newEmail = "";
  let appRelevantDataContextValue = context;
  let t = appRelevantDataContextValue.t;
  if (!modifiedState.existingOwnerEmail || modifiedState.existingOwnerEmail.trim().length === 0) {
    modifiedState.errors.existingOwnerEmail = "Email ID is required";
    setState(modifiedState);
    return;
  }
  if (!validEmailRegex.test(modifiedState.existingOwnerEmail)) {
    modifiedState.errors.existingOwnerEmail = "Enter a valid Email ID";
    setState(modifiedState);
    return;
  }
  const jsonParams = {
    email: modifiedState.existingOwnerEmail.toLowerCase()
  };
  axios.post(`${getAPIHostURL()}/wclient/changeOwnerEmailVerify`, jsonParams)
    .then(response => {
      if(response.data.code == 'SUCCESS') {

        const owner = response.data.result;
        if(!owner || Object.keys(owner).length === 0) {
          modifiedState.errors.existingOwnerOthers = `User with email '${modifiedState.existingOwnerEmail} not found'`;
          modifiedState.showOwnerDetails = false;
          modifiedState.ownerDetails = null;
          modifiedState.deviceListText = "";
          modifiedState.newEmail = "";
        } else if(modifiedState.existingOwnerEmail == PROD_DEVC_OWNER_USER_ID ){
              modifiedState.errors.existingOwnerOthers = `${modifiedState.existingOwnerEmail} cannot be the Existing Owner Email ID.`;
        } else {
            // ---------- Email exists, populate owner details ----------
            modifiedState.showOwnerDetails = true;
            modifiedState.ownerDetails = {
              firstName: owner.firstName,
              lastName: owner.lastName,
              phone: owner.phoneNo
            };
            // Devices check
            if (!Array.isArray(owner.devices) || owner.devices.length === 0) {
              // when there are No devices
              modifiedState.deviceListText = "";
              modifiedState.errors.deviceList = "";
              modifiedState.errors.deviceList = "No devices found for this user";
            } else {
              // when Devices exist
              const devicesText = owner.devices.map(d => `${d.deviceID} - ${d.deviceName}`).join("\n");
              modifiedState.deviceListText = devicesText;
              modifiedState.deviceList = owner.devices;
              modifiedState.errors.deviceList = "";
              
            }
        }
      } 
      else {
        // ---------- Backend returned an error ----------
        if (response.data.code === "NO_DEVICES") {
          modifiedState.errors.existingOwnerOthers = response.data.failuremessage;
          
        } else if (response.data.code === "SQL_ERROR") {
          modifiedState.errors.existingOwnerOthers = "Server experiencing issues. Try again later.";
        } else {
          modifiedState.errors.existingOwnerOthers = "Server experiencing issues. Try again later.";
        }
      }

      // Clear previous email errors
      modifiedState.errors.existingOwnerEmail = "";
      modifiedState.errors.newEmail = "";
      setState(modifiedState);
      
    })
    .catch((error) => {
      if (axios.isCancel(error)) {
        console.log('Axios request cancelled because of too many requests being sent to the Server.');
      } else {
        modifiedState.errors.others = "Network error. Please try again.";
        setState(modifiedState);
      }
    });
  };

  //Function to display the device id and name in the list of devices box.
  const handleDeviceSelect = (device) => {
    setState((prev) => {
      const alreadyExists = prev.searchedDevices.some(
        (d) => d.deviceID === device.deviceID
      );
      if (alreadyExists) {
        return {
          ...prev,
          highlightedSearchedDeviceId: device.deviceID, 
        };
      }
      return {
        ...prev,
        selectedDevice: `${device.deviceID} - ${device.deviceName}`,
        searchedDevices: [device, ...prev.searchedDevices],
        highlightedSearchedDeviceId: device.deviceID, 
        errors: {
        ...prev.errors,
        deviceList: "", // Clear submit validation error
      },
      };
    });
  };

  //Function to display the selected devices to the selected devices list.
  const handleSelectAllDevices = () => {
    setState((prev) => {
      // If already all selected -- unselect all
      if (prev.searchedDevices.length === prev.deviceList.length) {
        return {
          ...prev,
          searchedDevices: [],
          selectedDevice: "",
          errors: {
            ...prev.errors,
            deviceList: "",
          },
        };
      }
      // Else select all
      return {
        ...prev,
        searchedDevices: [...prev.deviceList],
        selectedDevice: "",
        errors: {
          ...prev.errors,
          deviceList: "",
        },
      };
    });
  };
  
  //Function to remove the device id and name .
  const handleRemoveSearchedDevice = (deviceID) => {
    setState((prev) => {
      const updatedDevices = prev.searchedDevices.filter(
        (d) => d.deviceID !== deviceID
      );
      return {
        ...prev,
        searchedDevices: updatedDevices,
        selectedDevice: updatedDevices.length ? prev.selectedDevice : "",
      };
    });
  };

  //Verification for change owner email.
  const handleVerifyNewEmail = (e) => {
    e.preventDefault();
    let modifiedState = { ...state };
    modifiedState.errors.newEmail = "";
    modifiedState.errors.newOwnerOthers = "";

    if (!modifiedState.newEmail || modifiedState.newEmail.trim().length === 0) {
      modifiedState.errors.newEmail = "Email ID is required.";
      setState(modifiedState);
      return;
    }
    if(modifiedState.newEmail.trim().toLowerCase() === modifiedState.existingOwnerEmail.trim().toLowerCase()){
      modifiedState.errors.newEmail = "The New Email ID cannot be the same as the Existing Email ID."
      modifiedState.showNewOwnerDetails = false;
      modifiedState.newOwnerDetails = null;

      setState(modifiedState);
      return;
    }

    if (!validEmailRegex.test(modifiedState.newEmail)) {
      modifiedState.errors.newEmail = "Enter a valid Email ID.";
      setState(modifiedState);
      return;
    }
    const jsonParams = { 
      email: modifiedState.newEmail.toLowerCase()
     };
    axios.post(`${getAPIHostURL()}/wclient/verifyEmailForRegisteringDevice`, jsonParams)
      .then(response => {
        if (response.data.code === 'SUCCESS') {
          const owner = response.data.retrivedLatestTreeNodeID?.[0];
          if (!owner || Object.keys(owner).length === 0) {
            modifiedState.errors.newOwnerOthers = `User with email '${modifiedState.newEmail}' not found.`;
            modifiedState.showNewOwnerDetails = false;
            modifiedState.newOwnerDetails = null;
          } else if(modifiedState.newEmail == PROD_DEVC_OWNER_USER_ID ){
              modifiedState.errors.newOwnerOthers = `${modifiedState.newEmail} cannot be the Existing Owner Email ID. `;
          } else {
            modifiedState.showNewOwnerDetails = true;
            modifiedState.newOwnerDetails = {
              firstName: owner.firstName,
              lastName: owner.lastName,
              phone: owner.phoneNo
            };
            modifiedState.errors.newEmail = "";
          }
        } else {
          if (response.data.code === "USER_NOT_REGISTERED") {
            modifiedState.errors.newOwnerOthers = response.data.failuremessage;
          } else if (response.data.code === "SQL_ERROR") {
            modifiedState.errors.newOwnerOthers = "Server experiencing issues. Try again later.";
          } else {
            modifiedState.errors.newOwnerOthers = "Server experiencing issues. Try again later.";
          }
          modifiedState.showNewOwnerDetails = false;
          modifiedState.newOwnerDetails = null;
        }
        setState(modifiedState);
      })
      .catch((error) => {
        if (axios.isCancel(error)) {
          console.log('Axios request cancelled because of too many requests being sent to the Server.');
        } else {
          modifiedState.errors.others = "Network error. Please try again.";
          setState(modifiedState);
        }
      });
    };

    const handleSubmit = (e) => {
      e.preventDefault();
      let modifiedState = { ...state };
      // validate all the input fields in the devices.
      if(!modifiedState.searchedDevices || modifiedState.searchedDevices.length <= 0 ){
         modifiedState.errors.deviceList = "Please select at least one device.";
         setState(modifiedState);
         return;
      }
      if(!modifiedState.existingOwnerEmail || modifiedState.existingOwnerEmail.length <= 0){
        modifiedState.errors.existingOwnerEmail = "Please enter an Email ID.";
        setState(modifiedState);
        return;
      }
      if(!modifiedState.newEmail || modifiedState.newEmail.length <= 0){
        modifiedState.errors.newEmail = "Please enter an Email ID.";
        setState(modifiedState);
        return;
      }
      const confirmRegister = window.confirm("Do you want to change the owner of the device(s)?");
      if (!confirmRegister) {
        alert("Change Owner cancelled.");
        return;
      }
      const jsonParams = {
        existingOwnerEmail: modifiedState.existingOwnerEmail.trim().toLowerCase(),
        newOwnerEmail: modifiedState.newEmail.trim().toLowerCase(),
        devices: modifiedState.searchedDevices.map((device) => ({
          deviceID: device.deviceID,
          deviceName: device.deviceName,
        })),
      };
      axios.post(`${getAPIHostURL()}/wclient/changeOwnerSubmitVerify`, jsonParams)
      .then(response => {
        if (response.data.code === 'SUCCESS') {
          alert("Owner changed successfully.");
        
            //Clear all the fields.
            modifiedState.deviceId =  ""
            modifiedState.existingOwnerEmail =  "";
            modifiedState.allowViewAll =  false;
            modifiedState.selectedDevice =  "";
            modifiedState.searchedDeviceText =  "";
            modifiedState.searchedDevices =  [];
            modifiedState.newEmail =  "";
            modifiedState.deviceList =  [];
            modifiedState.deviceListText =  "";
            modifiedState.devcIDQRCodeFlag =  false;
            modifiedState.showOwnerDetails =  false;
            modifiedState.highlightedSearchedDeviceId =  null;

            modifiedState.ownerDetails =  null;

            modifiedState.showNewOwnerDetails =  false;
            modifiedState.newOwnerDetails =  null;

            modifiedState.errors = {
              existingOwnerEmail: "",
              newEmail: "",
              deviceList: "",
              existingOwnerOthers: "",
              newOwnerOthers: "",
              others: "",
            };          
        } else{
            if (response.data.code === 'REQ_PARAMS_MISSING') {
              modifiedState.errors.others = "Server experiencing issues (required parameters not sent). Try again later.";
            } else if (response.data.code === "SQL_ERROR") {
              modifiedState.errors.others = "Server experiencing issues. Try again later.";
            } else {
              modifiedState.errors.others = "Server experiencing issues. Try again later.";
            }
        }
        setState(modifiedState);

      }).catch((error) => {
        if (axios.isCancel(error)) {
          console.log('Axios request cancelled because of too many requests being sent to the Server.');
        } else {
          modifiedState.errors.others = "Network error. Please try again.";
          setState(modifiedState);
        }
      });
    };

    return (
    <>
      <div className="addCustbox">
        <div className="headingForComponentsOfCrmPage">Change Device Owner</div>
        <form>
          <div className="form-group addCustFormChangeOwner">
            <label className="addCustFormLabelWithRequiredFiledChangeOwner">
              Existing Owner Email ID
              <span className="addCustRequiredMarkStar">*</span>
            </label>
            <div className="emailfixes">
              <div className="inlineFieldRow" >
                <input
                  type="email"
                  className="addCustInputForm emailInput"
                  name="existingOwnerEmail" 
                  value={state.existingOwnerEmail}
                  onChange={handleChange}
                  placeholder="Enter existing owner email"
                />
                <button
                  type="button"
                  className="addDeviceBtnInlineChangeOwner"
                  disabled={!!state.errors.existingOwnerEmail || !state.existingOwnerEmail}
                  onClick={handleVerifyOwner}
                >
                  Verify
                </button>
              </div>
              {state.errors.existingOwnerEmail && (
              <div className="addCustError">{state.errors.existingOwnerEmail}</div>
              )}
              {state.errors.existingOwnerOthers && (
                <div className="addCustError">{state.errors.existingOwnerOthers}</div>
              )}
            </div>
          </div>
          {state.showOwnerDetails && state.ownerDetails &&  (
              <div className="form-group">
              <div className="fullWidthMobile" >
                <div style={{ width: "100%", display: "flex", justifyContent: "center", marginBottom: "8px" }}>
                  <span style={{ fontWeight: 450, fontSize: "1rem" }}>
                    Existing Owner Details:
                  </span>
                </div>
                <div className="ownerDetailsTableWrapper">
                  <table className="ownerDetailsTable">
                    <thead>
                      <tr>
                        <th>First Name</th>
                        <th>Last Name</th>
                        <th>Phone Number</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{state.ownerDetails.firstName || "-"}</td>
                        <td>{state.ownerDetails.lastName || "-"}</td>
                        <td>{state.ownerDetails.phone || "-"}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                
                {/* Parallel textareas: List of Devices and Searched Device */}
                {state.deviceList && state.deviceList.length > 0 &&(
                  <div className="deviceListsRow">
                    {/* List of Devices */}
                    <div className="deviceListWrapper">
                      {/* Header row */}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginBottom: "6px",
                        }}
                      >
                        <label style={{ marginBottom: 0 }}>List of Devices</label>
                        <span
                          className="selectAllText"
                          onClick={handleSelectAllDevices}
                        >
                          {isAllSelected ? "Unselect All" : "Select All"}
                        </span>
                      </div>
                      <ul className="deviceListContainer">
                        {state.deviceList && state.deviceList.length > 0 ? (
                          state.deviceList.map((device, index) => (
                            <li key={index} 
                            className={`deviceItem ${ state.searchedDevices.some( (d) => d.deviceID === device.deviceID)
                              ? "selected"
                              : ""
                          }`}
                          onClick={() => handleDeviceSelect(device)}
                          >
                          {`${device.deviceID} - ${device.deviceName}`}
                            </li>
                          ))
                        ) : (
                          <li className="noDevices">No devices available</li>
                        )}
                      </ul>
                      </div>
                      {/* Searched Device */}
                      <div className="searchedDeviceWrapper">
                        <label>Selected Device</label>
                        <ul className="searchedDeviceContainer">
                          {state.searchedDevices.map((device) => (
                            <li
                              key={device.deviceID}
                              className={`searchedDeviceItem ${
                                state.highlightedSearchedDeviceId === device.deviceID ? "selected" : ""
                              }`}
                            >
                              <span>{`${device.deviceID} - ${device.deviceName}`}</span>
                              <button
                                type="button"
                                className="removeDeviceBtn"
                                onClick={() => handleRemoveSearchedDevice(device.deviceID)}
                              >
                                <FaTimes />
                              </button>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  )}
                  {state.errors.deviceList && (
                      <div className="addCustError" style={{textAlign:"center", color: "var(--errorColor)" , 
                        fontSize:"1rem" , marginTop:"4px" , minHeight:"1.2rem"}}>{state.errors.deviceList}</div>
                    )}
              </div>
          </div>
        )}
        {/* New or Changed Email */}
        {/* {state.showOwnerDetails && state.deviceList.length > 0 && ( */}
        {state.showOwnerDetails && state.deviceList && state.deviceList.length > 0 && (
          <div className="form-group addCustFormChangeOwner">
            <label className="addCustFormLabelWithRequiredFiledChangeOwner">
              New or Changed Email ID
              <span className="addCustRequiredMarkStar">*</span>
            </label>
            <div  className="emailfixes">
              <div className="inlineFieldRow">
                <input
                  type="email"
                  className="newEmailInput addCustInputForm"
                  name="newEmail"
                  value={state.newEmail}
                  onChange={handleChange}
                  placeholder="Enter new email"
                />
                <button
                  type="button"
                  className="addDeviceBtnInlineChangeOwner"
                  disabled={!!state.errors.newEmail || !state.newEmail}
                  onClick={handleVerifyNewEmail}
                  >
                  Verify
                </button>
              </div>
              {state.errors.newEmail && (
              <div className="addCustError">{state.errors.newEmail}</div>
              )}
              {state.errors.newOwnerOthers && (
                <div className="addCustError">{state.errors.newOwnerOthers}</div>
              )}
              </div>
            </div>
          )}
          {state.showNewOwnerDetails && state.newOwnerDetails && (
            <div className="form-group">
            <div className="fullWidthMobile">
              {/* Centered label – same as previous table */}
              <div style={{ width: "100%", display: "flex", justifyContent: "center", marginBottom: "8px", }} >
                <span style={{ fontWeight: 450, fontSize: "1rem" }}>
                Changed Owner Details:
                </span>
                </div>
                <div className="ownerDetailsTableWrapper">
                  <table className="ownerDetailsTable">
                    <thead>
                      <tr>
                        <th>First Name</th>
                        <th>Last Name</th>
                        <th>Phone Number</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{state.newOwnerDetails.firstName || "-"}</td>
                        <td>{state.newOwnerDetails.lastName || "-"}</td>
                        <td>{state.newOwnerDetails.phone || "-"}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
          </div>
          )}
          {/* Submit Button */}
          {state.showOwnerDetails && state.showNewOwnerDetails && (
            <div
               className="form-group"
              style={{ display: "flex", justifyContent: "center", marginTop: "2rem" }}
            >
              <button
                type="submit"
                className="addDeviceBtn"
                onClick={handleSubmit}
              >
                Submit
              </button>
            </div>
          )}
          {state.errors.others && (
            <div className="addCustError" style={{textAlign:"center", color: "var(--errorColor)" , 
            fontSize:"1rem" , marginTop:"4px" , minHeight:"1.2rem"}}>{state.errors.others}</div>
          )}
        </form>
      </div>
    </>
  );
}
export default VcChangeOwner;
